import { createSlice } from '@reduxjs/toolkit';

export const assetOwnersSlice = createSlice({
    name: 'assetOwners',
    initialState: {
        data: null,
        error: null
    },
    reducers: {
        setAssetOwners: (state, action) => {
            const data = action?.payload;
            if (!(typeof data === 'object' && data !== null)) {
                return { ...state };
            }
            return {
                ...state,
                data: {
                    assetsInAOIOwners: data.assetsInAOIOwners,
                    operationalZone: data.operationalZone,
                    nationalOrRegional: data.nationalOrRegional
                }
            };
        },
        clearAssetOwners: (state, action) => {
            // Clears all Asset Owners and errors
            return {
                ...state,
                data: null,
                error: null
            };
        },
        setAssetOwnersError: (state, action) => {
            return {
                data: null,
                error: action?.payload
            };
        }
    }
});

export const {
    setAssetOwners,
    clearAssetOwners,
    setAssetOwnersError
} = assetOwnersSlice.actions;

export default assetOwnersSlice.reducer;
